import { Injector } from '@angular/core';

/**
 * Singleton service for the app injector.
 *
 * This is used in base classes to obtain references to services so the extending component does
 * not need to inject all the required dependencies for the base class.
 *
 * It is also used to get access to services when using helper functions that are not Angular services.
 */
export class AppInjectorService {
  private static _injector: Injector;

  public static get injector(): Injector {
    return this._injector;
  }

  public static set injector(injector: Injector) {
    this._injector = injector;
  }
}
